import React, { useCallback, useEffect, useMemo } from 'react';
import { useForm, useFormState } from 'react-final-form';
import Accordion from '../../../../../../../components/Accordion';
import ProtectedComponent from '../../../../../../../router/components/ProtectedComponent';
import authEnums from '../../../../../../../utilities/enums/authEnums';
import rcuEnums from '../../../../../../../utilities/enums/rcuEnums';
import SupportingDocumentsRCU from '../../../KYCServicesV3/components/DataCollection/components/SupportingDocumentsRCU';

const DataCollectionLegalEntity = ({ namePrefix, accordionOpen }) => {
  const { values } = useFormState();

  const dataCollection = useMemo(
    () => (values[namePrefix] ? values[namePrefix].dataCollection : values.dataCollection),
    [values],
  );

  const { change } = useForm();

  const namePrefixWithDot = useMemo(() => (namePrefix ? `${namePrefix}.` : ''), [namePrefix]);

  const handleRequestSupportingDocumentsChange = useCallback(
    value => {
      if (value && !dataCollection?.packagesTypes) {
        change(`${namePrefixWithDot}dataCollection.packagesTypes`, [{ assignedUserId: null, package: null }]);
      }
      if (!value) {
        change(`${namePrefixWithDot}dataCollection.packagesTypes`, []);
      }
    },
    [change, namePrefixWithDot, dataCollection?.packagesTypes],
  );

  useEffect(() => {
    dataCollection?.requestSupportingDocuments && handleRequestSupportingDocumentsChange(true);
  }, []);

  return (
    <ProtectedComponent
      permissionGroup={authEnums.PERMISSION_GROUP.DOCUMENTS}
      requiredPermissions={[authEnums.PERMISSION_TAGS_MAPPING.requestClientUpdate]}
    >
      <Accordion
        accordionindex={rcuEnums.ACCORDION_INDEXES.DATA_COLLECTION}
        accordionOpen={accordionOpen}
        title={
          <>
            <h3>Data Collection</h3>
            <span className={`${namePrefix}-spacer`} />
          </>
        }
      >
        <SupportingDocumentsRCU
          namePrefix={namePrefix}
          handleRequestSupportingDocumentsChange={handleRequestSupportingDocumentsChange}
        />
      </Accordion>
    </ProtectedComponent>
  );
};
export default DataCollectionLegalEntity;
